import type { UserPayload } from '@Application/Users/Users/Actions/usersFetched';

export type UserUpdatedPayload = UserPayload;

export type UserUpdatedAction = {
	type: 'USER_UPDATED';
	payload: UserUpdatedPayload;
	accountId: number;
};

export default (payload: UserUpdatedPayload, accountId: number): UserUpdatedAction => ({
	type: 'USER_UPDATED',
	payload,
	accountId,
});
